import React from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const bonuses = [{
  num: '01',
  title: 'Guía de Pacientes Difíciles',
  desc: 'Más adherencia, menos abandono y mejores resultados.',
  price: '$12.000'
}, {
  num: '02',
  title: 'Respuestas a Preguntas Frecuentes',
  desc: 'Respuestas claras para las dudas más comunes en consulta.',
  price: '$9.000'
}, {
  num: '03',
  title: 'Kit de Alta del Paciente',
  desc: 'Cómo cerrar procesos de forma profesional.',
  price: '$10.000'
}, {
  num: '04',
  title: 'Guía de Derivación Inteligente',
  desc: 'Cuándo derivar y cómo tomar mejores decisiones clínicas.',
  price: '$9.000'
}, {
  num: '05',
  title: 'Guía Práctica de Antropometría',
  desc: 'Mediciones y seguimiento corporal simplificados.',
  price: '$8.000'
}];
export function Bonuses() {
  useTrackSection('bonuses', 'Bonuses Section');
  return <section id="bonuses" className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(248,250,252) 0%, rgb(255,255,255) 18%, rgb(255,255,255) 72%, rgb(240,253,244) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-48">
      <div className="mx-auto max-w-4xl" data-id="element-49">
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-50">
          Además recibís{' '}
          <span className="text-green-700" data-id="element-51">5 Bonos Exclusivos</span>
        </h2>

        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-52">
          Recursos extra para resolver consultas más rápido, transmitir más
          valor profesional y trabajar con mayor seguridad.
        </p>

        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-53">
          <div className="bg-green-700 px-5 py-2.5" data-id="element-54">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-55">
              🎁 LOS 5 BONOS — Incluidos siempre
            </h3>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-56">
            {bonuses.map(bonus => <div key={bonus.num} className="flex items-center gap-4 px-5 py-3" data-id="element-57">
                <span className="shrink-0 text-lg font-black text-green-700/30 w-8 text-center" data-id="element-58">
                  {bonus.num}
                </span>

                <div className="flex-1 min-w-0" data-id="element-59">
                  <span className="block text-sm font-black text-gray-900" data-id="element-60">
                    {bonus.title}
                  </span>

                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-61">
                    {bonus.desc}
                  </span>
                </div>

                <div className="shrink-0 flex flex-col items-end gap-0.5" data-id="element-62">
                  <span className="text-[10px] text-gray-400 line-through" data-id="element-63">
                    {bonus.price}
                  </span>

                  <span className="text-[10px] font-black text-white bg-green-700 rounded-full px-2 py-0.5" data-id="element-64">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center rounded-xl px-5 py-3 shadow-sm" style={{
        backgroundColor: 'rgb(240,253,244)',
        border: '1px solid rgba(34,197,94,0.3)'
      }} data-id="element-65">
          <p className="text-xs font-bold uppercase tracking-widest text-green-700 m-0 mb-1" data-id="element-66">
            Valor total de los bonos
          </p>

          <div className="flex items-center justify-center gap-3" data-id="element-67">
            <span className="text-base text-gray-400 line-through" data-id="element-68">
              $48.000
            </span>

            <span className="text-lg font-black text-green-700" data-id="element-69">
              🎁 GRATIS
            </span>
          </div>
        </div>
      </div>
    </section>;
}